import dollar from "./reports/dollar.png";
import check_doc from "./reports/check_doc.png";
import doc_check_green from "./docCheckGreen.png";
import doc_check_red from "./docCheckRed.png";
import doc_check_yellow from "./docCheckYellow.png";
import paymentBgImg from "./paymentBgImg.png";
import clearingBgImg from "./clearingBgImg.png";
import report_parked from "./reports/report_parked.png";
import report_approved from "./reports/report_approved.png";
import report_rejected from "./reports/report_rejected.png";
import invoice_report from "./reports/invoice_report.png";
import payment_report from "./reports/payment_report.png";
import ar_360_report from "./reports/ar_360_report.png";
import tolerance from "./reports/tolerance.png";
import incident from "./reports/incidents.png";
import pending_bills from "./reports/pending_bills.png";
import owner_dashboard from "./owner_dashboard.png";
import camsLogo from "./camsLogo.png";
import no_newsletter from "./no_newsletter.png";
import invoice_awaiting from "./invoice_awaiting.png";
import expense_performance from "./expense_performance.png";
import income_performance from "./income_performance.png";
import no_data from "./noData.svg";
import custom_template from "./template/custom.png";
import predefined_template from "./template/predefined.png";

export const images = {
  dollar,
  check_doc,
  report_parked,
  report_approved,
  report_rejected,
  doc_check_green,
  doc_check_red,
  doc_check_yellow,
  paymentBgImg,
  clearingBgImg,
  invoice_report,
  payment_report,
  tolerance,
  ar_360_report,
  incident,
  pending_bills,
  owner_dashboard,
  camsLogo,
  no_newsletter,
  invoice_awaiting,
  expense_performance,
  income_performance,
  no_data,
  custom_template,
  predefined_template
};
